import type { RouteModel } from '@polaris/core/models'
import type {
  SwapSwapCompletedProperties,
  SwapSwapSignedProperties,
} from '../codegen/ampli'

export function makeSwapSignedProperties({
  route,
}: {
  route: RouteModel
}): Omit<SwapSwapSignedProperties, 'page'> {
  return {
    feeValueUSD: route.feeValueUsd,
    valueUSD: route.usdValueAmountOut,
    fromToken: `${route.InputAssetMetadata.display_name}:${route.InputAssetMetadata.ticker}`,
    toToken: `${route.OutputAssetMetadata.display_name}:${route.OutputAssetMetadata.ticker}`,
    fromChain: route.sourceChain.chain_name,
    toChain: route.destinationChain.chain_name,
    fromTokenAmount: String(route.AmountIn),
    toTokenAmount: String(route.AmountOut),
    routeID: route.ID,
  }
}

export function makeSwapSignedComplete({
  route,
}: {
  route: RouteModel
}): Omit<SwapSwapCompletedProperties, 'page' | 'timeToSwap'> {
  return {
    feeValueUSD: route.Steps.map((step) => step.step_fee_in_usd).reduce(
      (fees, fee) => fees + fee,
      0,
    ),
    valueUSD: route.OutputAssetUSDPrice * route.AmountOut,
    fromToken: `${route.InputAssetMetadata.display_name}:${route.InputAssetMetadata.ticker}`,
    toToken: `${route.OutputAssetMetadata.display_name}:${route.OutputAssetMetadata.ticker}`,
    fromChain: route.Steps[0].from_chain.chain_name,
    toChain: route.Steps[route.Steps.length - 1].to_chain.chain_name,
    fromTokenAmount: String(route.AmountIn),
    toTokenAmount: String(route.AmountOut),
    routeID: route.ID,
  }
}
